// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript_wrapper__-9Z3T {
  background-color: var(--backgroundColor);
}

.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U {
    position: -webkit-sticky;
    position: sticky;
    bottom: 8px;

    display: flex;
    gap: 4px;
    align-items: center;
    align-self: center;

    margin-top: 12px;
    padding: 8px 14px 8px 14px;
    border-radius: 3px;

    font-size: 14px;
    font-weight: 700;
    line-height: 17.07px;
    color: var(--backgroundColor);

    forced-color-adjust: preserve-parent-color;
    background-color: var(--textColor);
    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);
  }

.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U,.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U svg {
      transition-timing-function: ease-in-out;
      transition-duration: 0.2s;
      transition-property: background-color, color, fill;
    }

@media (prefers-contrast: more) {
      .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U,.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U .transcript_syncWithVideoButton__UQB2U {
        border: 1px solid var(--borderColor);
      }
    }

@media (forced-colors: active) {
      .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U,.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U .transcript_syncWithVideoButton__UQB2U {
        border: 1px solid ButtonBorder;
      }
      .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U .transcript_menuItem__ydbBA {
        border-bottom: 1px solid ButtonBorder;
      }
    }

@media (prefers-reduced-motion: reduce) {
      .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U,.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U svg {
        transition: none;
      }
    }

.dark .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover {
  background-color: rgba(245, 245, 245, 1);
}

.light .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover {
  background-color: rgba(51, 51, 51, 1);
}

@media (forced-colors: active) {
    .dark .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover {
      color: HighlightText;
      background-color: Highlight;
    }
    .light .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover {
      color: HighlightText;
      background-color: Highlight;
    }
    .dark .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover span {
      color: HighlightText;
      background-color: Highlight;
    }
    .light .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover span {
      color: HighlightText;
      background-color: Highlight;
    }
    .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover:not(.transcript_does-not-exist__tyXSF),.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover:not(.transcript_does-not-exist__tyXSF) span {
      color: HighlightText;
      background-color: Highlight;
    }
    .dark .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover svg {
      color: HighlightText;
      fill: HighlightText;
    }
    .light .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover svg {
      color: HighlightText;
      fill: HighlightText;
    }
    .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover:not(.transcript_does-not-exist__tyXSF) svg {
      color: HighlightText;
      fill: HighlightText;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/transcript/transcript.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAuD1C;;AArDE;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,WAAW;;IAEX,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;;IAElB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;;IAE7B,0CAA0C;IAC1C,kCAAkC;IAClC,+CAA+C;EAgCjD;;AA9BE;MAEE,uCAAuC;MACvC,yBAAyB;MACzB,kDAAkD;IACpD;;AAEA;MACE;QAEE,oCAAoC;MACtC;IACF;;AAEA;MACE;QAEE,8BAA8B;MAChC;MACA;QACE,qCAAqC;MACvC;IACF;;AAEA;MACE;QAEE,gBAAgB;MAClB;IACF;;AAIJ;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;IAII;MAEE,oBAAoB;MACpB,2BAA2B;IAC7B;IAJA;MAEE,oBAAoB;MACpB,2BAA2B;IAC7B;IAJA;MAEE,oBAAoB;MACpB,2BAA2B;IAC7B;IAJA;MAEE,oBAAoB;MACpB,2BAA2B;IAC7B;IAJA;MAEE,oBAAoB;MACpB,2BAA2B;IAC7B;IACA;MACE,oBAAoB;MACpB,mBAAmB;IACrB;IAHA;MACE,oBAAoB;MACpB,mBAAmB;IACrB;IAHA;MACE,oBAAoB;MACpB,mBAAmB;IACrB;AAEJ","sourcesContent":[".wrapper {\n  background-color: var(--backgroundColor);\n\n  & .syncWithVideoButton {\n    position: sticky;\n    bottom: 8px;\n\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    align-self: center;\n\n    margin-top: 12px;\n    padding: 8px 14px 8px 14px;\n    border-radius: 3px;\n\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17.07px;\n    color: var(--backgroundColor);\n\n    forced-color-adjust: preserve-parent-color;\n    background-color: var(--textColor);\n    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n    &,\n    & svg {\n      transition-timing-function: ease-in-out;\n      transition-duration: 0.2s;\n      transition-property: background-color, color, fill;\n    }\n\n    @media (prefers-contrast: more) {\n      &,\n      & .syncWithVideoButton {\n        border: 1px solid var(--borderColor);\n      }\n    }\n\n    @media (forced-colors: active) {\n      &,\n      & .syncWithVideoButton {\n        border: 1px solid ButtonBorder;\n      }\n      & .menuItem {\n        border-bottom: 1px solid ButtonBorder;\n      }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      &,\n      & svg {\n        transition: none;\n      }\n    }\n  }\n}\n\n:global(.dark) .wrapper .syncWithVideoButton:hover {\n  background-color: rgba(245, 245, 245, 1);\n}\n\n:global(.light) .wrapper .syncWithVideoButton:hover {\n  background-color: rgba(51, 51, 51, 1);\n}\n\n@media (forced-colors: active) {\n  .wrapper .syncWithVideoButton:hover,\n  :global(.dark) .wrapper .syncWithVideoButton:hover,\n  :global(.light) .wrapper .syncWithVideoButton:hover {\n    &,\n    & span {\n      color: HighlightText;\n      background-color: Highlight;\n    }\n    & svg {\n      color: HighlightText;\n      fill: HighlightText;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `transcript_wrapper__-9Z3T`,
	"syncWithVideoButton": `transcript_syncWithVideoButton__UQB2U`,
	"menuItem": `transcript_menuItem__ydbBA`,
	"doesNotExist": `transcript_does-not-exist__tyXSF`
};
module.exports = ___CSS_LOADER_EXPORT___;
